
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useAppSelector } from '../../../app/hooks';

interface OeeDialProps {
    title: string,
    alias: string,
    attributeGuid: string
    value: number
}

export default function OeeDial(props: OeeDialProps) {
    const attributes = useAppSelector((state) => state.attributesSlice.attributes);
    let oeeValue = 0;

    if (props.attributeGuid && props.attributeGuid !== undefined) {
        var value = attributes.find(attribute => attribute.Guid === props.attributeGuid)?.Values;
        oeeValue = value && typeof value[value.length - 1].Value == 'number' ? Number(value[value.length - 1].Value) : 0;
    }
    else {
        oeeValue = props.value;
    }

    const pathColor = oeeValue > 80 ? "#00B464" : "#FCC449"; // Green if above 80, Red otherwise

    return (
        <>
            <div className="grid columns-1 justify-center h-44  flex-1">
                <div className="text-text-light dark:text-text-dark text-sm font-bold flex">
                    <div className='grow h-6' >
                        <div className='line-clamp-2 text-center break-words overflow-hidden'>{props.alias ? props.alias : ""}</div>
                    </div>
                </div>
                <div className='flex justify-center items-center relative'>
                    <div className="absolute font-semibold text-text-dark">
                        {typeof oeeValue === 'number' ? `${Math.round(oeeValue)}%` : "-"}
                    </div>

                    <div style={{ width: '4rem', height: '4rem' }}>
                        <CircularProgressbar value={oeeValue} background
                            backgroundPadding={0}
                            strokeWidth={15}
                            styles={buildStyles({
                                pathColor: pathColor,
                                backgroundColor: "#494949",
                                trailColor: "#494949",
                                strokeLinecap: "butt"
                            })} />
                    </div>
                </div>
                <div className="text-center text-text-light dark:text-text-dark
                 pt-1 text-sm font-semibold">
                    {props.title}
                </div>
            </div>
        </>
    )
}